import { apiRequest } from "./apiClient";
export const getAllPatients = async () => {
  return await apiRequest({ method: "GET", endpoint: "/patients" });
};

export const deletePatient = async (patientId) => {
  return await apiRequest({
    method: "GET", 
    endpoint: `/patients/${patientId}`,
  });
};

export const upsertPatient = async (payload) => {
  return await apiRequest({
    method: "POST",
    endpoint: "/patients",
    body: payload,
  });
};